import { render, staticRenderFns } from "./BlockSlider.vue?vue&type=template&id=c16b9aca&scoped=true&"
import script from "./BlockSlider.vue?vue&type=script&lang=ts&"
export * from "./BlockSlider.vue?vue&type=script&lang=ts&"
import style0 from "./BlockSlider.vue?vue&type=style&index=0&id=c16b9aca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16b9aca",
  null
  
)

export default component.exports